// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"5c104796","787":"ce7b5d44"}[chunkId] + ".chunk.js";
};